import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "dark", toggle: () => {}, setTheme: () => {} });

// Priority when resolving the initial theme: URL ?theme= → saved preference → brand default (dark).
function readInitial() {
  if (typeof window === "undefined") return "dark";
  try {
    const url = new URLSearchParams(window.location.search).get("theme");
    if (url === "light" || url === "dark") return url;
    const saved = localStorage.getItem("ragi-theme");
    if (saved === "light" || saved === "dark") return saved;
  } catch { /* ignore */ }
  return "dark";
}

function reflectInUrl(t) {
  try {
    const u = new URL(window.location.href);
    u.searchParams.set("theme", t);
    window.history.replaceState({}, "", u);
  } catch { /* ignore */ }
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(readInitial);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "light") root.setAttribute("data-theme", "light");
    else root.removeAttribute("data-theme");
    try { localStorage.setItem("ragi-theme", theme); } catch { /* ignore */ }
  }, [theme]);

  // Explicit selection (from the switch) — also reflects the choice in the URL.
  const setTheme = (t) => {
    if (t !== "light" && t !== "dark") return;
    setThemeState(t);
    reflectInUrl(t);
  };
  const toggle = () => setTheme(theme === "dark" ? "light" : "dark");

  return (
    <ThemeContext.Provider value={{ theme, toggle, setTheme }}>{children}</ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
